import { FlowVariable, FlowVariableBehavior } from "../interfaces/flow/variable/FlowVariable";
import { WebRequestAction } from "../interfaces/flow/action/WebRequestAction";

export const newFlowVariable = (name: string, value: string,behavior:FlowVariableBehavior, instruction: string):FlowVariable  => {
  return { name:name,value:value, instruction:instruction, behavior:behavior };
};

export const addNewFlowVariable = (action: WebRequestAction, flowVariable: FlowVariable) => {
  action.flowVariables?.push(newFlowVariable(flowVariable.name,flowVariable.value,flowVariable.behavior as FlowVariableBehavior,flowVariable.instruction));
  if (!action.flowVariables) {
    action.flowVariables = [newFlowVariable(flowVariable.name,flowVariable.value,flowVariable.behavior  as FlowVariableBehavior,flowVariable.instruction)];
  }
};